import isPlainObject from 'lodash/isPlainObject';

export const getText = (msg, formatMessage) => {
  if (isPlainObject(msg) && msg.id) {
    return formatMessage(msg);
  }

  return msg;
};



// WEBPACK FOOTER //
// ./src/utils/ui/getText.js